import type { Merchant } from '~platform/entities/merchant';
import type { Pos } from '~platform/entities/pos';

import {
  getCorrectDateRange,
  keepExistingIds,
  readPersistedJson,
  writePersistedJson,
} from '~shared/lib/persisted-filters';
import type { DateRange } from '~shared/ui/date-range-picker';

import { endOfDay, startOfDay, subDays } from 'date-fns';

export type DashboardFiltersValue = {
  period: DateRange;
  merchantIds: string[];
  posIds: string[];
};

export const DASHBOARD_FILTERS_STORAGE_KEY = 'dashboardFilters.v2';

export const DEFAULT_DASHBOARD_PERIOD_DAYS = 7;

export const getDefaultDashboardFilter = (): DashboardFiltersValue => ({
  period: {
    startDate: startOfDay(
      subDays(new Date(), DEFAULT_DASHBOARD_PERIOD_DAYS)
    ).toISOString(),
    endDate: endOfDay(new Date()).toISOString(),
  },
  merchantIds: [],
  posIds: [],
});

export const restoreDashboardFilters = (
  merchants: Merchant[],
  posList: Pos[]
): DashboardFiltersValue => {
  const defaults = getDefaultDashboardFilter();
  const saved = readPersistedJson<Partial<DashboardFiltersValue>>(
    DASHBOARD_FILTERS_STORAGE_KEY
  );

  if (!saved) {
    return defaults;
  }

  return {
    period: getCorrectDateRange(saved.period, defaults.period),
    merchantIds: keepExistingIds(
      saved.merchantIds,
      merchants.map(({ id }) => id)
    ),
    posIds: keepExistingIds(
      saved.posIds,
      posList.map(({ id }) => id)
    ),
  };
};

export const persistDashboardFilters = (filters: DashboardFiltersValue) => {
  writePersistedJson(DASHBOARD_FILTERS_STORAGE_KEY, filters);
};
